import React from "react";
import { Helmet } from "react-helmet-async";
import { Container, Card } from "react-bootstrap";
import "./LegalPages.css";

export default function TermsAndConditions() {
    const siteName = "Shivay Tour & Travells";
    const siteUrl = "https://www.shivaytourandtravells.com";
    const contactEmail = "shivaytourandtravells@gmail.com";
    const effectiveDate = "October 6, 2025";

    return (
        <Container className="legal-page my-5">
            <Helmet>
                <title>Terms & Conditions | {siteName}</title>
                <meta
                    name="description"
                    content={`${siteName} Terms & Conditions — rules for using our travel website and booking services.`}
                />
            </Helmet>

            <div className="text-center mb-5">
                <h1 className="legal-heading">Terms & Conditions</h1>
                <p className="lead text-secondary">Effective Date: {effectiveDate}</p>
            </div>

            <Card className="p-4 shadow-lg border-0 rounded-4">
                <section>
                    <h3>1. Acceptance of Terms</h3>
                    <p>
                        By accessing or using <a href={siteUrl}>{siteUrl}</a> (“the Site”), you agree to comply with and be bound
                        by these Terms and Conditions. If you do not agree with any part of these terms, please discontinue use
                        of our website and services immediately.
                    </p>
                </section>

                <section>
                    <h3>2. Bookings and Payments</h3>
                    <ul>
                        <li>All bookings are subject to availability and confirmation by {siteName}.</li>
                        <li>Payment terms and due dates will be specified on your invoice or confirmation email.</li>
                        <li>We use secure third-party payment gateways and do not store card details on our servers.</li>
                        <li>Prices are subject to change due to external factors like taxes or exchange rates.</li>
                    </ul>
                </section>

                <section>
                    <h3>3. Cancellations and Refunds</h3>
                    <p>
                        Cancellation requests must be made in writing via email. Refund eligibility depends on partner policies.
                        Please refer to our <a href="/refund-policy">Refund Policy</a> for details.
                    </p>
                </section>

                <section>
                    <h3>4. User Responsibilities</h3>
                    <ul>
                        <li>Provide accurate information during booking.</li>
                        <li>Ensure valid travel documents (passport, visa, etc.) before travel.</li>
                        <li>Do not use our website for unlawful or fraudulent purposes.</li>
                    </ul>
                </section>

                <section>
                    <h3>5. Intellectual Property</h3>
                    <p>
                        All website content (text, images, graphics, logos) is owned by {siteName}. Reproduction or distribution is
                        prohibited without permission.
                    </p>
                </section>

                <section>
                    <h3>6. Third-Party Links</h3>
                    <p>
                        Our website may contain external links. {siteName} is not responsible for their content or practices.
                        Visiting such links is at your own risk.
                    </p>
                </section>

                <section>
                    <h3>7. Limitation of Liability</h3>
                    <p>
                        {siteName} acts only as a booking intermediary. We are not liable for damages, delays, or losses caused by
                        third parties or unforeseen events.
                    </p>
                </section>

                <section>
                    <h3>8. Force Majeure</h3>
                    <p>
                        We are not responsible for service failures due to natural disasters, pandemics, wars, or technical failures.
                    </p>
                </section>

                <section>
                    <h3>9. Governing Law</h3>
                    <p>
                        These Terms are governed by Indian law. Any disputes fall under the jurisdiction of Surat, Gujarat courts.
                    </p>
                </section>

                <section>
                    <h3>10. Amendments</h3>
                    <p>
                        {siteName} may modify these Terms at any time. Updates will appear on this page with a new effective date.
                    </p>
                </section>

                <section>
                    <h3>11. Contact Us</h3>
                    <p>
                        For questions regarding these Terms & Conditions, contact:{" "}
                        <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                    </p>
                </section>

                <p className="text-muted small mt-4 text-center">
                    Last updated: {effectiveDate}
                </p>
            </Card>
        </Container>
    );
}
